import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'src/utils/AxiosConfig';

export const addUserProfile = createAsyncThunk(
  'appUsers/addUserProfile',
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const profileData = {
        user_id: parseInt(data.user_id),
        date_of_birth: data.date_of_birth || null,
        blood_group: data.blood_group || null,
        hobbies: data.hobbies || null,
        education_history: data.education_history || null,
        known_languages: Array.isArray(data.known_languages) ? data.known_languages : []
      };
      const response = await axios.post('/api/profile', profileData);
      return response.data;
    } catch (error) {
      console.error('Profile creation error:', error.response?.data || error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
)

export const updateUserProfile = createAsyncThunk(
  'appUsers/updateUserProfile',
  async ({ user_id, ...data}, { getState, dispatch, rejectWithValue }) => {
    try {
      
   const response = await axios.put(`/api/profile/${user_id}`, {
      user_id,
      ...data
      });
      return response.data;
    } catch (error) {
      console.error('Profile update error:', error.response?.data || error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
)

export const appProfileSlice = createSlice({
  name: 'appProfile',
  initialState: {
    data: {},
    status: 'idle',
    message: null,
    errors: null
  },
  reducers: {
    resetProfile: (state) => {
      state.data = {};
      state.status = 'idle';
      state.message = null;
      state.errors = null;
    }
  },
  extraReducers: (builder) => {
    // Add User Profile
    builder
      .addCase(addUserProfile.pending, (state) => {
        state.status = 'loading';
        state.message = null;
        state.errors = null;
      })
      .addCase(addUserProfile.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(addUserProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload?.message;
        state.errors = action.payload?.errors;
      })

    // Update User Profile
    builder
      .addCase(updateUserProfile.pending, (state) => {
        state.status = 'loading';
        state.message = null;
        state.errors = null;
      })
      .addCase(updateUserProfile.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload?.message;
        state.errors = action.payload?.errors;
      });
  }
});

export const { resetProfile } = appProfileSlice.actions;

export default appProfileSlice.reducer;